import { ToggleExpandButton } from '@innovyze/stylovyze/lib/components';
import React, { useRef } from 'react';
import { InlineDiv, RelativeDiv, AbsoluteDiv } from './OrgSwitcher.styles';
import OrgSwitcherMenu from './OrgSwitcherMenu';
export default function OrgList({ menuOpen, orgList, setMenuOpen, }) {
    const menuAnchorRef = useRef(null);
    const openMenu = () => setMenuOpen(true);
    const closeMenu = () => setMenuOpen(false);
    if (!orgList?.length)
        return null;
    return (React.createElement(InlineDiv, null,
        React.createElement(ToggleExpandButton, { menuOpen: menuOpen, onClick: openMenu }),
        React.createElement(RelativeDiv, null,
            React.createElement(AbsoluteDiv, { ref: menuAnchorRef })),
        React.createElement(OrgSwitcherMenu, { closeMenu: closeMenu, menuAnchorRef: menuAnchorRef, menuOpen: menuOpen }, orgList)));
}
